import React from 'react';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Outlet } from 'react-router-dom';
export function App() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Outlet data-id="element-3" />
      </main>
      <Footer data-id="element-4" />
    </div>;
}